export function recordIkigaiRouteLocalOutcome(llm, outcome) {
    if (!outcome)
        return;
    try {
        llm?.recordRouteLocalOutcome?.(outcome);
    }
    catch {
        // Telemetry must not affect route-local fallback behavior.
    }
}
//# sourceMappingURL=route-local-outcome.js.map